/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { TabPanel as TabPanelBasic } from '../tabs';

export const TabPanel = styled(TabPanelBasic)``;